if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          return;
        }
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
               const submitBtn = this.submitButton;
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              // this.submitButtonText.classList.add('hidden');
              // soldOutMessage.classList.remove('hidden');
              // inject CSS once
if (!document.getElementById('cart-limit-popup-styles')) {
  const style = document.createElement('style');
  style.id = 'cart-limit-popup-styles';
  style.textContent = `
    #cart-limit-popup{position:fixed;inset:0;display:none;z-index:9999}
    #cart-limit-popup.active{display:block}
    .cart-limit-popup__overlay{position:absolute;inset:0;background:rgba(0,0,0,0.45)}
    .cart-limit-popup__box{position:relative;max-width:360px;margin:12% auto;background:#fff;padding:16px;border-radius:8px;box-shadow:0 8px 30px rgba(0,0,0,0.25);text-align:center}
    .cart-limit-popup__title{font-size:1rem;margin:0 0 .5rem;color:#111}
    .cart-limit-popup__message{margin:0 0 1rem;color:#333}
    .cart-limit-popup__close{background:#111;color:#fff;border:none;padding:.5rem 1rem;border-radius:6px;cursor:pointer}
    .cart-limit-popup__close:focus{outline:2px solid #000; outline-offset:2px}
  `;
  document.head.appendChild(style);
}

// create popup if missing
let popup = document.getElementById('cart-limit-popup');
if (!popup) {
  popup = document.createElement('div');
  popup.id = 'cart-limit-popup';
  popup.innerHTML = `
    <div class="cart-limit-popup__overlay" data-close tabindex="-1"></div>
    <div class="cart-limit-popup__box" role="dialog" aria-modal="true" aria-labelledby="cart-limit-popup-title" tabindex="-1">
      <h2 id="cart-limit-popup-title" class="cart-limit-popup__title">Quantity limit reached</h2>
      <p class="cart-limit-popup__message">You already added the maximum available quantity.</p>
      <div><button type="button" class="cart-limit-popup__close">OK</button></div>
    </div>
  `;
  document.body.appendChild(popup);
}

// references
const overlay = popup.querySelector('.cart-limit-popup__overlay');
const closeBtn = popup.querySelector('.cart-limit-popup__close');
const msgEl = popup.querySelector('.cart-limit-popup__message');

// helper functions
const escHandler = (e) => { if (e.key === 'Escape') closePopup(); };
function closePopup() {
  popup.classList.remove('active');
  document.body.style.overflow = '';
  document.removeEventListener('keydown', escHandler);
  try { submitBtn.focus(); } catch (e) {}
}
function openPopup(message) {
  if (message) msgEl.textContent = message;
  popup.classList.add('active');
  document.body.style.overflow = 'hidden';
  try { closeBtn.focus(); } catch (e) {}
  document.addEventListener('keydown', escHandler);
}

// ensure listeners (removing first to avoid duplicates)
try { overlay.removeEventListener('click', closePopup); } catch(e){}
overlay.addEventListener('click', closePopup);
try { closeBtn.removeEventListener('click', closePopup); } catch(e){}
closeBtn.addEventListener('click', closePopup);

// show popup
openPopup("You already added the maximum available quantity.");
function closePopup() {
  popup.classList.remove('active');
  document.body.style.overflow = '';
  document.removeEventListener('keydown', escHandler);
  location.reload(); // reload page after closing
}

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

handleErrorMessage(errorMessage = false) {
  if (this.hideErrors) return;

  this.errorMessageWrapper =
    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
  if (!this.errorMessageWrapper) return;
  this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

  this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

  if (errorMessage) {
    // Replace generic message with your custom one
    const customMessage = 'Sorry, this quantity isn’t available.';
    this.errorMessage.textContent = customMessage;
  }
}

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) {
          return;
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      
      get variantIdInput() {
        // return this.form.querySelector('[name=id]');
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
